export const removeAllVuePreloadHiddenClasses = () => {
  const className = 'vue-preload-hidden';
  const elements = document.querySelectorAll(`.${className}`);

  for (let i = 0; i < elements.length; ++i) {
    elements[i].classList.remove(className);
  }
};

export const removeAllVuePostloadHiddenElements = () => {
  const className = 'vue-postload-hidden';
  const elements = document.querySelectorAll(`.${className}`);

  for (let i = 0; i < elements.length; ++i) {
    elements[i].parentNode.removeChild(elements[i]);
  }
};
